import { cartStoreArgs } from "@/router/storefrontStoreId";

/**
 * ONE store's cart AS THE SERVER HAS IT: the `store_cart` Account RPC.
 *
 * Carts are keyed by (account, store) and the account payload carries no
 * cart, so this is the client's one cart read (per-store carts U5/U6). The
 * lines come back exactly as stored -- this store's only, each with its
 * stable `line_id` -- so nothing is filtered here. The owner is the
 * request's: an anonymous storefront session reads its own token's cart.
 *
 * No store id, no request: `cartStoreArgs` throws before anything is sent.
 * THROWS on any failure or a response with no cart array, so a caller cannot
 * mistake "could not read" for "empty".
 */
export async function fetchStoreCart(http, accountId, storeId) {
  const args = cartStoreArgs(storeId);
  const response = await http.post(`/accounts/${accountId}/store_cart`, {
    meta: { method: "store_cart", args },
  });
  const cart = response?.data?.meta?.result?.cart;
  if (!Array.isArray(cart)) {
    throw new Error("store_cart returned no cart");
  }
  return cart;
}

/** The server's code for a request naming a store it is not for. */
export const CART_STORE_MISMATCH = "CART_STORE_MISMATCH";

/**
 * The message to show when `err` is the server's store-mismatch 409, else
 * null. That 409 is NOT the checkout staleness 409 ("prices changed"): the
 * cart is for a different store than this page, and reloading is the fix.
 */
export function cartStoreMismatchMessage(err) {
  const response = err && err.response;
  if (!response || response.status !== 409) return null;
  const errors = response.data && response.data.errors;
  const first = Array.isArray(errors) ? errors[0] : null;
  if (!first || first.code !== CART_STORE_MISMATCH) return null;
  return typeof first.detail === "string" && first.detail.trim()
    ? first.detail.trim()
    : "Your cart is for another store. Reload this page.";
}
